export default __webpack_public_path__ + "static/SR USA - Customer Trade Application-13b6b876df8172a5f25dcc90c39c68fd.pdf";